
  export default {
    props: { label: { type: String, required: true } }
  };
